export default "__VITE_ASSET__BitYzI7j__"